module.exports = __webpack_public_path__ + "static/media/logo.a2f90a02.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 434
// module chunks = 0